import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "grid container" }
const _hoisted_2 = { class: "left-col" }
const _hoisted_3 = { class: "search row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon search magnify",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "path fill",
    d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Clear all", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon close times",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "path fill",
    d: "M19 6.4L17.6 5L12 10.6L6.4 5L5 6.4L10.6 12L5 17.6L6.4 19L12 13.4L17.6 19L19 17.6L13.4 12L19 6.4Z"
  })
], -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "filters col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "header name" }, "Filters", -1)
const _hoisted_10 = {
  key: 0,
  class: "icon minimize",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("rect", {
  class: "path fill",
  x: "5",
  y: "11",
  width: "14",
  height: "2"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "icon add plus more",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  class: "path fill",
  d: "M11 5V11H5V13H11V19H13V13H19V11H13V5H11Z"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("template", null, null, -1)
const _hoisted_17 = { class: "scroll-container scroll-y" }
const _hoisted_18 = { class: "section col" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "header name" }, "Location", -1)
const _hoisted_20 = {
  key: 0,
  class: "icon minimize",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("rect", {
  class: "path fill",
  x: "5",
  y: "11",
  width: "14",
  height: "2"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "icon add plus more",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  class: "path fill",
  d: "M11 5V11H5V13H11V19H13V13H19V11H13V5H11Z"
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "divider v" }, null, -1)
const _hoisted_27 = { class: "database-wrapper relative-container" }
const _hoisted_28 = { class: "content" }
const _hoisted_29 = { class: "scroll-container scroll-y" }
const _hoisted_30 = { class: "organizations list grid col" }
const _hoisted_31 = {
  key: 0,
  class: "row name no-results"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "col" }
const _hoisted_34 = {
  key: 0,
  class: "advocacy row"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "dog-ear" }, "Advocacy", -1)
const _hoisted_36 = { class: "np" }
const _hoisted_37 = { class: "row info" }
const _hoisted_38 = {
  key: 1,
  class: "row info"
}
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  key: 0,
  class: "advocacy"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "dog-ear" }, "Advocacy", -1)
const _hoisted_42 = { class: "np" }
const _hoisted_43 = {
  key: 0,
  class: "divider h"
}
const _hoisted_44 = { class: "page-nav middle row" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon arrow right",
  viewBox: "0 0 36 36",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    class: "fill bkg",
    width: "36",
    height: "36",
    rx: "18"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "28",
    y: "28",
    width: "20",
    height: "20"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "fill text-color",
    d: "M20.31 9.967L21.79 11.15L14.94 18L21.79 24.85L20.31 26.3L11.97 18L20.31 9.67Z"
  })
], -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = ["onClick", "disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon arrow right",
  viewBox: "0 0 36 36",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    class: "fill bkg",
    width: "36",
    height: "36",
    rx: "18"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "28",
    y: "28",
    width: "20",
    height: "20"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "fill text-color",
    d: "M15.46 26.33L13.98 24.85L20.83 18L13.98 11.15L15.46 9.67L23.79 18L15.46 26.33Z"
  })
], -1)
const _hoisted_51 = [
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.organizations.isReady && $setup.auth.user !== null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "database-tool",
        class: _normalizeClass($setup.deviceType)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                class: "search",
                placeholder: "Search for keyword",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event))
              }, null, 512), [
                [_vModelText, $setup.searchQuery]
              ]),
              _hoisted_4
            ]),
            _createElementVNode("button", {
              class: "clear clear-filters",
              onClick: $setup.clearFilters
            }, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["row name", ('showFilters'?'active':'')]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onSectionClick("filters")))
              }, [
                _hoisted_9,
                ($setup.showFilters)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15)),
                _hoisted_16
              ])
            ]),
            ($setup.showFilters)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["col pop-out", ('showFilters'?'active':'')])
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["row name", ('showLocation'? 'active': '')]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showLocation=!$setup.showLocation))
                      }, [
                        _hoisted_19,
                        ($setup.showLocation)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))
                      ]),
                      ($setup.showLocation)
                        ? (_openBlock(), _createBlock($setup["FilterSection"], {
                            key: 0,
                            class: "sub section col",
                            "filter-name": "Country",
                            options: $setup.organizations.HQCountryOptions,
                            "onUpdate:selectedOptions": _cache[3] || (_cache[3] = ($event: any) => ($setup.handleFilterSelection('Country', $event)))
                          }, null, 8, ["options"]))
                        : _createCommentVNode("", true),
                      ($setup.showLocation)
                        ? (_openBlock(), _createBlock($setup["FilterSection"], {
                            key: 1,
                            class: "sub section col",
                            "filter-name": "State/Province",
                            options: $setup.organizations.HQStateOptions,
                            "onUpdate:selectedOptions": _cache[4] || (_cache[4] = ($event: any) => ($setup.handleFilterSelection('State/Province', $event)))
                          }, null, 8, ["options"]))
                        : _createCommentVNode("", true),
                      _createVNode($setup["FilterSection"], {
                        class: "section col",
                        "filter-name": "Profit Type",
                        options: ['Non-Profit','For Profit'],
                        "onUpdate:selectedOptions": _cache[5] || (_cache[5] = ($event: any) => ($setup.handleFilterSelection('Profit Type', $event)))
                      }),
                      _createVNode($setup["FilterSection"], {
                        class: "section col",
                        "filter-name": "Focus",
                        options: ['Primarily ALS Focused', 'Related Disease Focus', 'Non ALS Focused'],
                        "onUpdate:selectedOptions": _cache[6] || (_cache[6] = ($event: any) => ($setup.handleFilterSelection('Focus', $event)))
                      }),
                      _createVNode($setup["FilterSection"], {
                        class: "section col",
                        "filter-name": "Services or Resources",
                        options: ['Raise Awareness', 'Online Resources', 'Conducts Research', 'Funds ALS Research', 'Consortia', 'Online Information'],
                        "onUpdate:selectedOptions": _cache[7] || (_cache[7] = ($event: any) => ($setup.handleFilterSelection('ServicesOrResources', $event)))
                      }),
                      _createVNode($setup["FilterSection"], {
                        class: "section col",
                        "filter-name": "Support Groups",
                        options: ['Online', 'In Person'],
                        "onUpdate:selectedOptions": _cache[8] || (_cache[8] = ($event: any) => ($setup.handleFilterSelection('Support Groups', $event)))
                      }),
                      _createVNode($setup["FilterSection"], {
                        class: "section col",
                        "filter-name": "Funds or Grants",
                        options: ['Home Care', 'Adaptive Tech', 'Research', 'Support Groups'],
                        "onUpdate:selectedOptions": _cache[9] || (_cache[9] = ($event: any) => ($setup.handleFilterSelection('FundsOrGrants', $event)))
                      }),
                      _createVNode($setup["FilterSection"], {
                        class: "section col",
                        "filter-name": "Organization Tags",
                        options: ['ALS AWARENESS', 'FUNDS ALS RESEARCH', 'CONDUCTS ALS RESEARCH', 'ADAPTIVE TECH OEM', 'FUNDS HOME CARE', 'IN PERSON SUPPORT GROUPS', 'PRIMARILY ALS FOCUSED', 'NON ALS FOCUSED', 'RELATED DISEASE', 'ALS DATABASE SYSTEM', 'CONSORTIA', 'ONLINE INFO SOURCE', 'ONLINE SUPPORT GROUPS', 'VETERANS RESOURCE', 'CHILDRENS RESOURCES', 'NON PROFIT', 'FOR PROFIT', 'GOVERNMENT ENTITY', 'POLICY OFFICERS', 'DRUG DEVELOPER / STAGE', 'VENTURE CAPITAL', 'PUBLICATIONS', 'ALTERNATIVE THERAPY', 'INTERNATIONAL'],
                        "onUpdate:selectedOptions": _cache[10] || (_cache[10] = ($event: any) => ($setup.handleFilterSelection('Organization Tags', $event)))
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  ($setup.paginatedOrganizations.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, "No results - Try clearing filters"))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedOrganizations, (org, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: org.id
                    }, [
                      _createElementVNode("div", {
                        class: "org-item row",
                        onClick: ($event: any) => ($setup.setOrgDetails(org))
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["row name", $setup.longNameClass(org['Organization Name'])])
                          }, _toDisplayString(org['Organization Name']), 3),
                          ($props.isMobile)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (org['NON PROFIT'] == false || org['NON PROFIT'] == true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _hoisted_35,
                                      _createElementVNode("div", _hoisted_36, _toDisplayString(org['NON PROFIT'] ? 'Non-Profit' : 'For Profit'), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, _toDisplayString(org['HQ Street Address']), 1),
                          (org['Office #'])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(org['Office #']), 1))
                            : _createCommentVNode("", true),
                          (org['Website'])
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                class: "row info website",
                                href: org['Website'],
                                target: "_blank"
                              }, _toDisplayString($setup.prettifyURLs(org['Website'])), 9, _hoisted_39))
                            : _createCommentVNode("", true)
                        ]),
                        (!$props.isMobile)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (org['NON PROFIT'] == false || org['NON PROFIT'] == true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _hoisted_41,
                                    _createElementVNode("div", _hoisted_42, _toDisplayString(org['NON PROFIT'] ? 'Non-Profit' : 'For Profit'), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_32),
                      (index != -1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            ($setup.loading)
              ? (_openBlock(), _createBlock($setup["Loader"], { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              class: "icon",
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.changePage('dec'))),
              disabled: $setup.currentPage < 2
            }, _hoisted_47, 8, _hoisted_45),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visiblePages, (page) => {
              return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["num", {'active': page === $setup.currentPage}]),
                onClick: ($event: any) => ($setup.currentPage = page),
                disabled: $setup.currentPage === page
              }, _toDisplayString(page), 11, _hoisted_48))
            }), 256)),
            _createElementVNode("button", {
              class: "icon",
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.changePage('inc'))),
              disabled: $setup.currentPage >= $setup.totalPages
            }, _hoisted_51, 8, _hoisted_49)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}